import React, { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { server } from "../common";
import Swal from "sweetalert2";
import withReacctContent from "sweetalert2-react-content";
import { AiFillDelete } from "react-icons/ai";
import { useSelectAccess } from "../store/stateFunctions";
import * as XLSX from "xlsx";
import withReactContent from "sweetalert2-react-content";

const swalalert = withReactContent(Swal);

const ContactFormEnquiries = ({ role }) => {
  const user = useSelectAccess("Super Admin");
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  // Get
  const getData = () => {
    server
      .get("/contact/getallcontacts", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error?.response?.data?.error);
        } else toast.error(error?.response?.data?.error);
      });
  };

  // Delete gallery
  const deleteInternShip = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.link} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/contact/deletecontact/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                // "auth-Token": user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire(
                  "Deleted!",
                  "Contact entry has been deleted.",
                  "success"
                );
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/contact/admfilter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const exportToExcel = () => {
    // Map over the data to include only the visible columns
    const exportData = data.map((app, index) => ({
      "Sr. No.": index + 1,
      "Application No.": app.id,
      " Date/Time": app.created_at,
      " Name": app.name,
      "Email Id": app.email,
      "Contact No.": app.mobile,
      Message: app.message,
    }));

    // Create Excel sheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Total Enquiries");
    XLSX.writeFile(workbook, "Total_Enquiries.xlsx");
  };

  return (
    <div>
      <div className="container mt-5 py-5">
        <h2 className="text-center ">Contact Entries</h2>
        <div className="container align-items-end py-1">
          <Button
            className="btn col-md-2 btn-sm"
            onClick={exportToExcel}
            variant="contained"
          >
            Export
          </Button>
        </div>
        <table className="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Mobile</th>
              <th scope="col">Message</th>
              <th scope="col">Delete</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              return (
                <>
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.email}</td>
                    <td>{item.mobile}</td>
                    <td>{item.message}</td>
                    <td>
                      <div className="btn btn-danger text-white">
                        <AiFillDelete onClick={() => deleteInternShip(item)} />
                      </div>
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContactFormEnquiries;
